"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceNonBreakingSpaces = exports.pasteHandler = exports.InsertEvent = void 0;
var HtmlToTokenConverter_1 = __importDefault(require("./HtmlToTokenConverter"));
var BehaviourBuilder_1 = require("./Behaviours/BehaviourBuilder");
var EditorTypes_1 = require("./EditorTypes");
var EventTransfer_1 = require("./EventTransfer");
var TokenConverter_1 = require("ContentTokens/TokenConverter");
var ImageToTokenConverter_1 = __importDefault(require("./ImageToTokenConverter"));
var Variables_1 = require("ContentTokens/DataModels/Variables");
var Deserialise_1 = require("./Tokenization/Deserialise");
var Serialise_1 = require("./Tokenization/Serialise");
var PreventHandledEvent_1 = require("./PreventHandledEvent");
var slate_react_1 = require("slate-react");
var InsertEvent = (function (_super) {
    __extends(InsertEvent, _super);
    function InsertEvent(tokens, extraArgs) {
        var _this = _super.call(this, EditorTypes_1.EventType.Insert) || this;
        _this.data = __assign({ tokens: tokens, leadingType: tokens[0].subType }, (extraArgs || {}));
        return _this;
    }
    Object.defineProperty(InsertEvent.prototype, "fragment", {
        get: function () {
            var value = (0, Deserialise_1.deserialise)(this.data.tokens).children;
            return value;
        },
        set: function (fragment) {
            this.data.tokens = (0, Serialise_1.serialise)(fragment);
        },
        enumerable: false,
        configurable: true
    });
    return InsertEvent;
}(EditorTypes_1.CustomEvent));
exports.InsertEvent = InsertEvent;
var hasEditableTarget = function (editor, target) {
    return target instanceof Node && slate_react_1.ReactEditor.hasDOMNode(editor, target, { editable: true });
};
var pasteHandler = function (editor, onEvent, conversionElem, uploadStore) {
    return (0, PreventHandledEvent_1.preventHandledEvent)(function (event) {
        var dataTransfer = event.clipboardData;
        var tokens = convertToTokens(dataTransfer, conversionElem, uploadStore);
        if (tokens.length) {
            var insertEvent = new InsertEvent(tokens, checkIsPastedVariable(dataTransfer));
            var wasHandled = onEvent(insertEvent, editor);
            return wasHandled;
        }
    });
};
exports.pasteHandler = pasteHandler;
var convertToTokens = function (dataTransfer, conversionElem, uploadStore) {
    var transfer = (0, EventTransfer_1.getEventTransfer)(dataTransfer);
    switch (transfer.type) {
        case BehaviourBuilder_1.PasteType.Fragment:
            return convertFragment(transfer.fragment);
        case BehaviourBuilder_1.PasteType.Html:
            return convertHtml(transfer, conversionElem);
        case BehaviourBuilder_1.PasteType.Text:
            return convertText(transfer);
        case BehaviourBuilder_1.PasteType.Files:
            return (0, ImageToTokenConverter_1.default)(transfer, uploadStore);
        default:
            return [];
    }
};
var convertFragment = function (transfer) {
    return (0, Serialise_1.serialise)(transfer);
};
var convertHtml = function (transfer, conversionElem) {
    var conversionDOMNode;
    if ((0, EditorTypes_1.isHTMLElement)(conversionElem)) {
        conversionDOMNode = conversionElem;
    }
    else {
        conversionDOMNode = conversionElem.current;
    }
    conversionDOMNode.innerHTML = transfer.html;
    var tokens = (0, HtmlToTokenConverter_1.default)(conversionDOMNode);
    return tokens;
};
var convertText = function (transfer) {
    var text = (0, exports.replaceNonBreakingSpaces)(transfer.text);
    return (0, TokenConverter_1.textToTokenConverter)(text, { fromClipboard: true });
};
var checkIsPastedVariable = function (dataTransfer) {
    var transfer = (0, EventTransfer_1.getEventTransfer)(dataTransfer);
    if (transfer.type === BehaviourBuilder_1.PasteType.Text) {
        var result = (0, Variables_1.isTextSerialisedVariable)(transfer.text);
        if (result.isValid) {
            return {
                isVariable: true,
                variable: result.variable,
            };
        }
    }
    return {
        isVariable: false,
    };
};
var replaceNonBreakingSpaces = function (str) {
    return str
        .replace(/\u00A0/g, " ")
        .replace(/\u202F/g, " ")
        .replace(/\uFEFF/g, "");
};
exports.replaceNonBreakingSpaces = replaceNonBreakingSpaces;
